export interface Options {
  [key: string]: any;
}

export interface Fn {
  (options: Options): Options;
}

export interface Plugins {
  [key: string]: Fn;
}
const plugins: Plugins = {}

export const regHistoryPlugin = (name: string, fn: Fn) => {
  if (!name || typeof fn !== 'function') {
    console.warn(`regHistoryPlugin: arguments are required. [name: string, fn: function]`);
    return;
  }
  if (plugins[name]) {
    const preFn = plugins[name];
    // 需要返回 options 到先注册过的方法中，后进先出
    plugins[name] = (options: Options): Options => preFn(fn(options));
  } else {
    // 默认源码处理，不再底层处理，容易诱发问题，这边单独再还原处理一次
    plugins[name] = (options: Options): any => {
      const newOptions = fn(options);
      if (name === 'createLocation') {
        // currentLocation: 当前的（只读）, locaiton: 即将更新的
        return newOptions.location;
      }
    };
  }
}

export function getHistoryPlugin(name?: string) {
  if (name && plugins[name]) {
    return plugins[name];
  }
  return plugins;
}
